import React from 'react';
import { Download, UserCheck, Clock, FileCheck } from 'lucide-react';
import LeadForm from './LeadForm';

export default function CTASection() {
  return (
    <section id="ebook" className="py-24 px-6 bg-slate-100" data-testid="cta-section">
      <div className="max-w-6xl mx-auto">
        <div className="bg-white border border-slate-200 overflow-hidden">
          <div className="grid lg:grid-cols-2">
            {/* Left - Info */}
            <div className="p-12 bg-slate-950 text-white">
              <span className="text-xs font-bold uppercase tracking-[0.2em] text-rose-400">
                Recurso gratuito
              </span>
              <h2 className="text-3xl lg:text-4xl font-bold tracking-tight mt-4">
                No deje su defensa legal al azar.
              </h2>
              <p className="mt-6 text-slate-300">
                Descargue ahora el protocolo completo de reincorporación y asegure su organización 
                ante la Inspección de Trabajo.
              </p>

              <ul className="mt-8 space-y-4">
                <li className="flex items-start gap-3">
                  <div className="w-8 h-8 bg-rose-600 flex items-center justify-center flex-shrink-0">
                    <UserCheck size={16} />
                  </div>
                  <div>
                    <h4 className="font-semibold">Modelo de carta de continuidad</h4>
                    <p className="text-sm text-slate-400">Adaptado a la Ley 2/2025</p>
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <div className="w-8 h-8 bg-rose-600 flex items-center justify-center flex-shrink-0">
                    <Clock size={16} />
                  </div>
                  <div>
                    <h4 className="font-semibold">Checklist de plazos</h4>
                    <p className="text-sm text-slate-400">10 días / 3 meses claramente explicados</p>
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <div className="w-8 h-8 bg-rose-600 flex items-center justify-center flex-shrink-0">
                    <FileCheck size={16} />
                  </div>
                  <div>
                    <h4 className="font-semibold">Guía de documentación</h4>
                    <p className="text-sm text-slate-400">Todo lo que debe solicitar al SPA</p>
                  </div>
                </li>
              </ul>

              <div className="mt-12 pt-8 border-t border-slate-800">
                <p className="text-xs text-slate-500">
                  Marco normativo actualizado a Marzo 2026. Incluye referencias a la Ley 2/2025 
                  y últimas sentencias del Tribunal Supremo.
                </p>
              </div>
            </div>

            {/* Right - Form */}
            <div className="p-12">
              <h3 className="text-xl font-bold text-slate-900 mb-6">
                Solicite el protocolo gratuito
              </h3>
              <LeadForm origen="cta_ebook" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
